import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, AlertService, ShadowService, GlobalService } from './shared/_services';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { CloseOverlayService } from './shared/_services/closeOverlay.service';
import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic';
import { FirebaseDynamicLinks } from '@ionic-native/firebase-dynamic-links/ngx';
import { DashboardStore, LoginStore, SignupStore } from './shared/_services/store';
import { environment, url } from 'src/environments/environment';
declare var cordova: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  providers: [LocalNotifications, FirebaseDynamicLinks]
})
export class AppComponent implements OnInit {
  currentUser: any;
  subscription: any;
  timedOut = false;
  loading = true;
  isCordova = this.platform.is('cordova');

  constructor(
    private zone: NgZone,
    private router: Router,
    private platform: Platform,
    private statusBar: StatusBar,
    private loginStore: LoginStore,
    private signupStore: SignupStore,
    private splashScreen: SplashScreen,
    private alertService: AlertService,
    private auth: AuthenticationService,
    private globalService: GlobalService,
    private dashboardStore: DashboardStore,
    private localNotifications: LocalNotifications,
    private closeOverlayService: CloseOverlayService,
    private firebaseDynamicLinks: FirebaseDynamicLinks
  ) {
    if (this.isCordova) {
      this.loginStore.setIsCordova(true);
      if (this.auth.currentUserValue) {
        this.router.navigateByUrl('/dashboard');
      } else {
        this.router.navigateByUrl('/login');
      }
    }

    if (this.dashboardStore.getCurrentUser()) {
      if (!this.auth.currentUserValue.details.accounts &&
          this.auth.currentUserValue.role === 'merchant'
        ) {
        console.log(this.auth.currentUserValue.details.accounts);
        this.auth.currentUserValue.details.accounts = [];
        this.dashboardStore.setCurrentUser(this.auth.currentUserValue);
        this.loginStore.setIsLoggedIn(true);
      }
      if (this.auth.currentUserValue.details.accountId === undefined &&
        this.auth.currentUserValue.role === 'cashier') {
        this.logout();
      }
    }

    if (this.loginStore.getIsRememberMeChecked() === 'false') {
      setTimeout(() => {
        this.auth.logout();
        this.router.navigateByUrl('/login');
      }, 8.64e7);
    }

    if (!this.loginStore.getIsOldStorageCleared()) {
      if (!this.loginStore.getIsCordova()) {
        this.clear();
      } else if (this.loginStore.getIsCordova() === 'true') {
        const version = '1.6.0' || '1.6.1';
        if (this.platform.is('android') && this.loginStore.getAppVersion() === version) {
          this.clear();
        } else if (this.platform.is('ios') && this.loginStore.getAppVersion() === '1.6.4') {
          this.clear();
        }
      }
    }

    this.auth.currentUser.subscribe(x => this.currentUser = x);

    const checkOnlineStatus = async () => {
      try {
        const online = await fetch('https://static-global-s-msn-com.akamaized.net/hp-neu/sc/2b/a5ea21.ico?=' + Date.now());
        this.closeOverlayService.trigger();
        return online.status >= 200 && online.status < 300;
      } catch {
        console.log('No connection');
        return false;
      }
    };

    const onlineInterval = setInterval(async () => {
      const onlineStatus = await checkOnlineStatus();
      console.log(onlineStatus);
    }, 3000);

    clearInterval(onlineInterval);

    const startApp = async () => {
      const online = await checkOnlineStatus();
      if (online) {
        this.initializeApp();
      } else {
        this.alertService.standardAlert('Error in Connection. Please check your internet connection');
      }
    };
    startApp();
  }

  initializeApp() {
    this.platform.ready().then((readySource) => {
      // this.bluetoothle.initialize().then(ble => {
      //   console.log('ble', ble.status);
      // });
      if (this.isCordova) {
        this.statusBar.styleDefault();
        this.splashScreen.hide();
        this.statusBar.backgroundColorByHexString('#fff');
        const appVersion = '1.6.9';
        this.loginStore.setAppVersion(appVersion);
        this.auth.getAppVersion().subscribe(
          (response: any) => {
            if (appVersion !== response[0].version && environment.production === true) {
              this.alertService.standardAlertWithButton(
                'New update available!',
                'Update your app to get the latest features and improvements',
                true,
                'Let\'s go!' //  if this text would change, it should also be changed in the alert service.
              );
            }
          }
        );
        cordova.plugins.firebase.dynamiclinks.getDynamicLink().then(
          (res: any) => {
            this.getReferralLink(res);
          },
          (error: any) => {
            console.log(error);
          }
        );
        this.firebaseDynamicLinks.onDynamicLink()
        .subscribe(
          (res: any) => {
            this.getReferralLink(res);
          }, error => {
            console.log(error);
          }
        );
        if (this.platform.is('android')) {
          FCM.onNotification().subscribe(data => {
            console.log('Notification came in', data);
            if (data.wasTapped) {
              console.log('Received in background', data);
              this.zone.run(() => {
                this.closeOverlayService.trigger();
                this.router.navigateByUrl('/dashboard');
                this.loginStore.setIsNotificationOpened(true);
              });
            } else {
              if (this.auth.currentUserValue.role === 'merchant') {
                console.log('Received in foreground', data);
                this.triggerNotificationForeground(data);
              }
            }
          }, error => { console.log('Error in notification', error); });
        } else {
          console.log('We are in iOS env - foreground');
          FCM.requestPushPermission()
          .then(
            (response => {
              console.log('Push Permissions received', response);
              // this.zone.run(() => {
              //   this.closeOverlayService.trigger();
              //   this.router.navigateByUrl('/dashboard');
              // });
            })
          );
        }

        FCM.getToken().then(token => {
          console.log('Device ID is ', token);
          this.loginStore.setDeviceId(token);
        }, error => { console.log('Error occurred', error); });
      } else {
        const search = window.location.search;
        const id = search.split('=')[1];
        if (search) {
          this.loginStore.setReferralId(id);
          if (search.includes('invitedBy')) {
            this.router.navigateByUrl('/signup');
          }
        }
      }
    });
  }

  getReferralLink(res: any) {
    const splitLink = res.deepLink.split('=');
    const id = splitLink[1];
    this.loginStore.setReferralId(id);
    console.log('Data got', res);
    this.zone.run(() => {
      if (res.deepLink.includes('=')) {
        this.router.navigateByUrl('/signup');
      } else {
        this.router.navigateByUrl('/login');
      }
    });
  }

  triggerNotificationForeground(data: any) {
    this.localNotifications.schedule([
      {
        id: new Date().getTime(),
        title: data.title,
        text: data.body,
        launch: true
      }
    ]);
    this.localNotifications.on('click')
    .subscribe(
      response => {
        console.log('Open notification and go to Dashboard', response);
        this.zone.run(() => {
          this.closeOverlayService.trigger();
          this.router.navigateByUrl('/dashboard');
          this.loginStore.setIsNotificationOpened(true);
        });
      }, error => {
        console.log(error);
      }
    );
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  clear() {
    this.loginStore.clearOldStorage();
    this.loginStore.setIsOldStorageCleared(true);
    if (this.isCordova) {
      this.alertService.loadingNullDuration('App updated! Please login again');
    }
  }

  ionViewDidEnter() {
  }

  ionViewDidLeave() {
    this.subscription = this.platform.backButton.unsubscribe();
  }

  ngOnInit(): void {
    if (!this.signupStore.getStates()) {
      this.globalService.getStates();
    }
    if (!this.loginStore.getBanks()) {
      this.globalService.getBanks();
    }
    const tag = document.createElement('script');
    tag.setAttribute('async', '');
    tag.src = 'https://www.googletagmanager.com/gtag/js?id=' + url.analyticsId;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    const analyticsTag = document.createElement('script');
    // tslint:disable-next-line:max-line-length
    analyticsTag.textContent = 'window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag(\'js\', new Date()); gtag(\'config\', \'' + url.analyticsId + '\');';
    const secondScriptTag = document.getElementsByTagName('script')[1];
    secondScriptTag.parentNode.insertBefore(analyticsTag, secondScriptTag);

    window.addEventListener('load', () => {
      this.loading = false;
    });
  }
}
